<div class="card">
    <div class="card-header">
        <div class="title">{{ 'EMPLOEE.POSITIONS' | translate }}</div>
        <div class="tools">
            <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }}
            </button>
        </div>
    </div>
    <div class="card-body">

        <table class="table table-hover">
            <thead>
                <tr>
                    <th scope="col" class="name">{{ 'EMPLOEE.JOB_TITLE' | translate }}</th>
                    <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let position of positions; let i = index">
                    <td class="name">
                        <span *ngIf="position.name; else elseNoName">{{ position.name }}</span>
                        <ng-template #elseNoName>-</ng-template>
                    </td>
                    <td class="action">
                        <button type="button" class="btn btn-light" (click)="onEdit(i)" placement="top"
                            ngbTooltip="{{ 'EDIT' | translate }}">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                        <!-- <button type="button" class="btn btn-light" (click)="onConfirm([position.id])" placement="top"
                            ngbTooltip="{{ 'DELETE' | translate }}">
                            <i class="bi bi bi-trash"></i>
                        </button> -->
                    </td>
                </tr>

                <tr *ngIf="positions.length == 0">
                    <td *ngIf="loading" class="data-loading" colspan="3">
                        <div class="spinner-bars">
                            <div class="loadingio-spinner-bars-preLoder-inner">
                                <div class="preLoder">
                                    <div></div><div></div><div></div><div></div>
                                </div>
                            </div>
                            <div>{{ 'LOADING' | translate }}</div>
                        </div>
                    </td>
                    <td *ngIf="!loading" class="data-not-found" colspan="3">
                        <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <div class="card-footer">
        <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
    </div>
</div>